$(document).on('submit', '[data-label-pdf]', function(event) {
  event.preventDefault();
  const $form = $(this);

  $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serializeArray(),
  }).then(() => {
    document.location.href = $form.attr('action');
  });
});
